import { render, staticRenderFns } from "./RelativesAdd.vue?vue&type=template&id=5349a04d&scoped=true&"
import script from "./RelativesAdd.vue?vue&type=script&lang=js&"
export * from "./RelativesAdd.vue?vue&type=script&lang=js&"
import style0 from "./RelativesAdd.vue?vue&type=style&index=0&id=5349a04d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349a04d",
  null
  
)

export default component.exports